import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import {Link} from 'react-router';
import {connect} from 'react-redux';
import {CSSProperties} from 'react';
import {CampusHeader} from '../Components/CampusHeader';
import {CampusFooter} from '../Components/CampusFooter';


class Shipping{
    key: number
    title: string;
    Content: any;
}
const letterSpace = '2px';

const multiLineStyle: CSSProperties = {
    textAlign:'left',
    padding:'10px'
}
const answerStyle:CSSProperties = {
    letterSpacing:'normal',
    paddingTop:'16px',
    paddingBottom:'16px'
}

let Questions: Shipping[] = [
{
    key: 1,
    title: "Standard Shipping",
    Content: <div><div style={answerStyle}>We pride ourselves on making sure you get your order on time, which is why most of our screen-printed apparel is available for a standard 5-7 business day turnaround. Other styles of decoration may take a little longer.</div><ul><li style={answerStyle}>Most screen-printed orders are available for 5-7 business day turnaround.</li><li style={answerStyle}>Embroidery turnaround can vary from 10-15 business days.</li><li style={answerStyle}>Some apparel styles may increase turnaround time due to availability.</li></ul><div style={answerStyle}>Your account manager will update you if something takes longer than our standard turnaround time.</div></div>
},{
    key: 2,
    title: "Expedited Shipping",
    Content: <div style={answerStyle}>We do offer a rush service for most apparel orders. If you need your order faster than 5-7 business days, contact us at 800-472-3269. *Rush services require additional charges</div>

},{
    key: 3,
    title: "Individual Link Shipments",
    Content:<div style={answerStyle}>All orders placed through our individual payment/sign-up links will ship in bulk to the address determined by the main buyer. If you’re not sure who set up your order, call us at 800-472-3269.</div>
},{
    key: 4,
    title: "Returns",
    Content: <div style={answerStyle}>We stand behind our products 100% and will do our best to provide excellent service. However, if you receive incorrect or damaged product please contact sales@grafcow.com with proof of the issue. Returns/refunds may be applicable and will be determined on a case by case basis. </div>
}
];




const itemStyle: CSSProperties = {
    fontSize: '13px',
    padding: '5px',
    margin: '5px 10px',
    cursor: 'pointer',
    letterSpacing: '2px',
    borderBottom:'1px solid rgba(87,144,161,0.2)',
    fontFamily:'BarlowLight',
    color:'#616060'
}

const containerStyle: CSSProperties = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    margin:'auto auto 200px auto',
    width:'43%'
}
const FAQHdr :CSSProperties = {
    textAlign:'center',
    fontFamily:'BarlowLight',
    color:'#616060'
}

const titleStyle: CSSProperties = {
    fontFamily:'Lulo',
    color:'#616060',
    fontSize:'14px',
    letterSpacing:'normal'
}

const contentStyle: CSSProperties = {
    fontFamily:'BarlowMedium',
    color:'#7C726E'
}
const issuesStyles : CSSProperties = {
    fontFamily:'BarlowMedium',
    marginTop:'15px'
}

class _CampusShipping extends React.Component<Tgcc.BaseProps, any>{

    componentDidMount(){
        var tag = document.getElementById('Shipping');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

  
    render(){
        return (
                <div>
                    <div id="Shipping"></div>
                    <CampusHeader />
                    <h2 style={FAQHdr}>Shipping &#38; Returns</h2>
                    <div style={containerStyle} className='shippingCont'>
                        {Questions.map( (question: Shipping) => { 
                        return (<div key={question.key} style={itemStyle}>
                                    <div style={titleStyle}>{question.title}</div><br/>
                                    <div style={contentStyle}>{question.Content}</div>
                                </div>)})}
                        <div style={issuesStyles}><i>&#42;Issues reported after 5 business days of receiving the product are NOT eligible for returns or refunds.</i></div>
                    </div>
                    <CampusFooter state={this.props.state} />
                </div>
            
        )
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { 
        state: state
    }
};
export var CampusShipping = connect(mapStateToProps)(_CampusShipping)